import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Discogs = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 1000 1000'
  >
    <path
      d='M359.3 499.7c0-78.3 63.5-141.8 141.7-141.8 78.3 0 141.7 63.4 141.7 141.8 0 78.3-63.5 141.7-141.7 141.7-78.2 0-141.7-63.4-141.7-141.7zm6.2 0c.2 74.9 60.7 135.4 135.5 135.5 74.8 0 135.6-60.7 135.6-135.5-.1-74.9-60.7-135.5-135.6-135.6-74.8 0-135.5 60.7-135.5 135.6z'
      fill={ color }
    />
    <path
      d='M523.5 499.7c0 12.3-10.1 22.3-22.4 22.3-12.3 0-22.4-10-22.4-22.3 0-12.4 10-22.4 22.4-22.4 12.3 0 22.4 10 22.4 22.4z'
      fill={ color }
    />
    <path
      d='M501.1 314.8c-102.2 0-184.9 82.8-184.9 184.9 0 52.2 21.7 99.2 56.5 132.8l-.6-.6-48.2 52.1c16.8 16.2 35.8 30.1 56.6 41.3l34.8-62c25.7 13.5 54.9 21.2 85.9 21.2 102.1 0 184.9-82.8 184.9-184.9 0-49.4-19.5-94.2-51-127.3l48.5-52.2c-16.5-16.7-35.2-31.2-55.7-42.9l-34.2 62.4c-27.4-15.7-58.9-24.8-92.6-24.8zM262.4 750.5l-49.2 53.2c26.2 24.8 55.4 46.3 87.3 63.7l35.5-63.2c-26.8-14.6-51.5-32.8-73.6-53.7zM745.1 253.8l49.3-53.1c-26.3-25.8-56-48.2-88.3-66.4l-34.8 63.6c27 15.4 51.8 34.2 73.8 55.9zM689.7 313.4l49.1-52.8c-21.4-21.3-45.6-39.6-72-54.6l-34.6 63.2c21.1 12.1 40.5 27 57.5 44.2zM317.6 690.8l-48.9 52.9c21.5 20.5 45.6 38.2 71.9 52.5l35.3-62.8c-21.4-11.5-41-25.9-58.3-42.6z'
      fill='none'
    />
    <path
      d='M245.1 499.7c0 72.4 30.2 137.8 78.7 184.4L372 632l.6.6c-34.8-33.6-56.5-80.7-56.5-132.8 0-102.1 82.7-184.9 184.9-184.9 33.7 0 65.2 9.1 92.4 24.9l34.2-62.4C590.2 256 547 243.8 501 243.8c-141-.2-255.9 114.7-255.9 255.9zM686 499.7c0 102.1-82.8 184.9-184.9 184.9-31 0-60.2-7.7-85.9-21.2l-34.8 62c36 19.3 77.1 30.3 120.7 30.3 141.2 0 256-114.8 256-256 0-69.9-28.2-133.3-73.7-179.5L635 372.3c31.5 33.2 51 78 51 127.4z'
      fill={ color }
    />
    <path
      d='M163.9 499.7c0 95.9 40.3 182.6 104.8 244.1l48.9-52.9c-50.3-48.3-81.7-116.1-81.7-191.2 0-146.3 119-265.2 265.2-265.2 47.6 0 92.3 12.7 131 34.8l34.6-63.2c-49-27.7-105.5-43.7-165.6-43.7-185.9 0-337.2 151.3-337.2 337.3zM766.4 499.7c0 146.3-119 265.2-265.2 265.2-45.3 0-87.9-11.4-125.3-31.5l-35.3 62.8c47.8 26 102.5 40.7 160.6 40.7 186 0 337.3-151.3 337.3-337.3 0-93.3-38.1-177.9-99.6-239.1l-49.1 52.8c47.3 48 76.6 113.8 76.6 186.4z'
      fill={ color }
    />
    <path
      d='M847.6 499.7c0 191.1-155.4 346.5-346.5 346.5-59.7 0-116-15.2-165.1-41.9l-35.5 63.2c59.6 32.6 128 51.2 200.6 51.2 231 0 419-188 419-419 0-117-48.2-222.8-125.7-298.9l-49.3 53.1c63.3 62.8 102.5 149.7 102.5 245.8zM82.1 499.7c0 119.6 50.5 227.6 131.1 304l49.2-53.2c-66.3-63.2-107.8-152.2-107.8-250.8 0-191.1 155.4-346.5 346.5-346.5 61.8 0 119.8 16.3 170.1 44.8l34.8-63.6c-60.6-34.2-130.5-53.7-204.9-53.7-231-.1-419 187.9-419 419z'
      fill={ color }
    />
    <path
      d='M848.8 142.3L800.7 194c79.3 77.8 128.7 186 128.7 305.7 0 236.1-192.1 428.2-428.2 428.2-74.3 0-144.2-19-205.1-52.4l-35.6 63.4c71.2 39.1 152.9 61.4 239.8 61.5 276.1 0 500.1-223.9 500.1-500-.2-140.5-58.3-267.3-151.6-358.1zM72.9 499.7C72.9 263.5 265 71.4 501.1 71.4c76 0 147.4 20 209.4 54.9l33.9-62C674.4 24.9 594 1.9 508.3.5h-8.1C225.7 1 3.3 221.7.3 495.7v4.8C.6 643.8 61 772.8 157.6 863.9l49.4-53.4C124.5 732.4 72.9 621.9 72.9 499.7z'
      fill={ color }
    />
  </svg>
);

Discogs.propTypes = { ...iconPropTypes };

Discogs.defaultProps = { ...iconDefaultProps };

export default Discogs;